// src/components/LoginModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useAuth } from './AuthProvider';
import { useLocation, useNavigate } from 'react-router-dom';

function LoginModal({ show, handleClose, className }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(''); // State for error messages
    const { login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const name = params.get('name');
        if (token && name) {
            if (token !== localStorage.getItem('token')) {
                login({ name }, token);
                navigate('/');
            }
        }
    }, [location, login, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(''); // Reset error message

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, { email, password });
            login(response.data.user, response.data.token); // Update the user state and token
            handleClose();
            // Optionally, reset form fields after successful login
            setEmail('');
            setPassword('');
        } catch (error) {
            console.error('Login failed', error);
            if (error.response && error.response.status === 401) {
                setError('Login failed. Please check your email and password.');
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
        }
    };

    const handleGoogleLogin = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}/auth/google`;
        handleClose();
    };

    // Clear error messages when the modal is opened
    useEffect(() => {
        if (show) {
            setError('');
        }
    }, [show]);

    return (
        <Modal show={show} onHide={handleClose} className={className}>
            <Modal.Header closeButton>
                <Modal.Title>Login</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Display error message if exists */}
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleLogin}>
                    <Form.Group controlId="formBasicEmail" className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className="mt-2">
                        Login
                    </Button>
                </Form>
                <Button onClick={handleGoogleLogin} variant="danger" className="mt-3">
                    Login with Google
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default LoginModal;
